import { render } from "./LoadingCard.vue?vue&type=template&id=7ea55be2&ts=true"
import script from "./LoadingCard.vue?vue&type=script&lang=ts"
export * from "./LoadingCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__